/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Words from ${i?.letters} — Unscramble | Toolverse`)
};

const es_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palabras con ${i?.letters} — Descifrar | Toolverse`)
};

const de_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wörter aus ${i?.letters} — Entwirren | Toolverse`)
};

const nl_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woorden van ${i?.letters} — Ontwarren | Toolverse`)
};

const fr_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mots avec ${i?.letters} — Déchiffrer | Toolverse`)
};

const it_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parole da ${i?.letters} — Sblocca | Toolverse`)
};

const pt_br2_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palavras a partir de ${i?.letters} — Desembaralhar | Toolverse`)
};

const pt_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palavras a partir de ${i?.letters} — Desbaralhar | Toolverse`)
};

const ja_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.letters} から作る単語 — 並べ替え | Toolverse`)
};

const zh_wu_letters_meta_title = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从 ${i?.letters} 拼出的单词 — 字母重组 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ letters: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_letters_meta_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_letters_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_letters_meta_title", locale)
	if (locale === "en") return en_wu_letters_meta_title(inputs)
	if (locale === "es") return es_wu_letters_meta_title(inputs)
	if (locale === "de") return de_wu_letters_meta_title(inputs)
	if (locale === "nl") return nl_wu_letters_meta_title(inputs)
	if (locale === "fr") return fr_wu_letters_meta_title(inputs)
	if (locale === "it") return it_wu_letters_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_wu_letters_meta_title(inputs)
	if (locale === "pt") return pt_wu_letters_meta_title(inputs)
	if (locale === "ja") return ja_wu_letters_meta_title(inputs)
	return zh_wu_letters_meta_title(inputs)
};